import React, { memo } from 'react';
import { ColorValueStrict } from 'fronton-react';
import { styled } from 'linaria/react';
import { Link, LinkProps } from '../../link';
import {
  Header,
  Size,
  Text,
  Typography,
  TypographyHeaderProps,
  TypographyTextProps,
  UnsizableText,
} from '../../typography';

export const CategoryCard = styled(Link)`
  width: 100%;
  height: 100%;
  padding: 24px;
  background-color: ${(props: LinkProps) => (props.bgcolor ? props.bgcolor : 'var(--background-secondary)')};
  border-radius: var(--rounding-m);

  &:hover {
    background-color: ${props => (props.hoverbgcolor ? props.hoverbgcolor : 'var(--control-minor)')};
  }
`;

type CategoryCardHeaderProps = {
  adaptive?: boolean;
  as?: keyof React.ReactHTML;
  className?: string;
  title: string;
} & ({ size: false; variant?: Header | UnsizableText } | { size?: Size; variant?: Text });

export const CategoryCardHeader: React.FC<CategoryCardHeaderProps> = memo(
  ({ adaptive, as, className, size = 'subtitle', title, variant = 'm' }) => {
    const textProps: TypographyHeaderProps | TypographyTextProps = size
      ? ({ size, variant } as TypographyTextProps)
      : ({ variant } as TypographyHeaderProps);

    return (
      <Typography adaptive={adaptive} as={as} className={className} {...textProps}>
        {title}
      </Typography>
    );
  }
);

type CategoryCardTextProps = {
  className?: string;
  color?: ColorValueStrict;
  text: string;
};

export const CategoryCardText: React.FC<CategoryCardTextProps> = ({
  className,
  color = 'text-secondary',
  text,
}) => (
  <Typography className={className} color={color} variant="s" size="body_short">
    {text}
  </Typography>
);

export const CategoryCardMedia = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 156px;
  height: 140px;
  border-radius: 0 var(--rounding-m) var(--rounding-m) 0;
`;
